<template>
  <v-layout row wrap>
    <v-dialog v-model="shower" scrollable persistent max-width="1200">
      <v-card>
        <v-card-title :style="'background:' + _cardTitle">
          <v-icon :color="_pageDetailcolor" size="30">mdi-file-find</v-icon>
          <h5 class="ml-3">
            {{ $t("settingsms_template.dialog.preview") }}
          </h5>
        </v-card-title>
        <v-divider></v-divider>
        <br />
        <v-card-text>
          <v-form ref="form">
            <v-layout row wrap justify-center mt-n1>
              <v-flex lg6 md6 sm11 xs11 pa-2>
                <v-card-text class="pa-2">
                  <v-layout row wrap justify-start align-center pb-3>
                    <v-flex xs11 sm11 md4 lg4>
                      <v-chip class="ma-2" color="warning">
                        {{ $t("settingemail.dialog.numCredit") }}
                        <b class="mr-1 ml-1" style="font-size: 20px"
                          >{{ numCreditSms }}
                        </b>
                      </v-chip>
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4></v-flex>
                    <v-flex xs11 sm11 md4 lg4></v-flex>
                  </v-layout>
                  <div class="message-blue">
                    <div class="message-content">
                      <p>
                        {{ dataSmsPreview }}
                      </p>
                    </div>
                    <div class="message-timestamp-left">
                      {{ $t("settingsms_template.dialog.example_sms") }}
                    </div>
                  </div>
                  <v-layout row wrap justify-start align-center>
                    <v-flex xs11 sm11 md6 lg6 pl-8>
                      <span class="red--text">
                        {{ $t("settingemail.dialog.noteNumCredit") }}
                      </span>
                    </v-flex>
                    <v-flex xs11 sm11 md2 lg2> </v-flex>
                    <v-flex xs11 sm11 md4 lg4 pl-8>
                      <span class="black--text"
                        >{{ $t("settingsms_template.dialog.num_count_text") }}
                        <b class="mr-1 ml-1" style="font-size: 20px">
                          {{ dataSmsPreview.length }}
                        </b>
                      </span>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center>
                    <v-flex lg11 md11 sm11 xs11 pa-2 pt-6>
                      <span class="black--text"
                        ><b>{{
                          $t("settingsms_template.dialog.tel_send_sms")
                        }}</b></span
                      >
                      <v-text-field
                        v-mask="mask"
                        :rules="[
                          (v) =>
                            !!v ||
                            $t('settingsms_template.condition.condition_phone'),
                        ]"
                        outlined
                        :label="$t('seach_resend.condition.phoneNumber')"
                        v-model="inputPhone"
                        :oninput="phoneRegex"
                        dense
                        class="pt-3"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-flex>

              <v-flex lg6 md6 sm11 xs11 pa-2>
                <v-card-text class="pa-2">
                  <h3 class="pb-2 black--text">
                    {{ $t("settingsms_template.dialog.data_test_title") }}
                  </h3>
                  <div v-for="item in newDataPreview" :key="item">
                    <!-- ชื่อบริษัท -->
                    <v-layout row wrap v-if="item === 'bussiness_name'" >
                      <v-flex lg3 md3 sm3 xs3 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numBussinessName"
                          :oninput="numberRegex"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2>
                        <v-text-field
                          outlined
                          :label="
                            $t('settingsms_template.dialog.bussiness_name')
                          "
                          v-model="bussinessName"
                          dense
                          counter
                          :disabled="numBussinessName.length < 1"
                          :maxlength="numBussinessName"
                          @input="fn_selector"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <!-- เลขที่สาขา -->
                    <v-layout row wrap mt-n4 v-if="item === 'seller_branch_id'">
                      <v-flex lg3 md3 sm3 xs3 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numsellerBranchId"
                          :oninput="numberRegex"
                          dense
                          disabled
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2>
                        <v-text-field
                          outlined
                          :label="
                            $t('settingsms_template.dialog.seller_branch_id')
                          "
                          v-model="sellerBranchId"
                          counter
                          :disabled="numsellerBranchId.length < 1"
                          :maxlength="numsellerBranchId"
                          :oninput="inputNumberRegex"
                          @input="fn_selector"
                          dense
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <!-- ชื่อผู้ซื้อ -->
                    <v-layout row wrap  mt-n4 v-if="item === 'buyer_name'">
                      <v-flex lg3 md3 sm3 xs3 pa-2 mt-n5>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numbuyerName"
                          :oninput="numberRegex"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2 mt-n5>
                        <v-text-field
                          outlined
                          :label="
                            $t('create_invoice.dialogBuyername.buyer_name')
                          "
                          v-model="buyerName"
                          counter
                          :disabled="numbuyerName.length < 1"
                          :maxlength="numbuyerName"
                          @input="fn_selector"
                          dense
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap  mt-n4 v-if="item === 'buyer_tax_id'">
                      <v-flex lg3 md3 sm3 xs3 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numbuyerTaxId"
                          :oninput="numberRegex"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.buyer_tax_id')"
                          v-model="buyerTaxId"
                          counter
                          :disabled="numbuyerTaxId.length < 1"
                          :maxlength="numbuyerTaxId"
                          :oninput="inputNumberRegex"
                          @input="fn_selector"
                          dense
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <!-- เลขประจำตัวผู้เสียภาษี -->
                    <v-layout row wrap  mt-n4 v-if="item === 'buyer_branch_id'">
                      <v-flex lg3 md3 sm3 xs3 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numbuyerBranchId"
                          :oninput="numberRegex"
                          dense
                          disabled
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2>
                        <v-text-field
                          outlined
                          :label="
                            $t('settingsms_template.dialog.buyer_branch_id')
                          "
                          v-model="buyerBranchId"
                          counter
                          :disabled="numbuyerBranchId.length < 1"
                          :maxlength="numbuyerBranchId"
                          :oninput="inputNumberRegex"
                          @input="fn_selector"
                          dense
                        ></v-text-field
                      ></v-flex>
                    </v-layout>
                    <!-- เลขที่เอกสาร -->
                    <v-layout row wrap  mt-n4 v-if="item === 'document_id'">
                      <v-flex lg3 md3 sm3 xs3 pa-2 mt-n5>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numdocumentId"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2 mt-n5>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.document_id')"
                          counter
                          :disabled="numdocumentId.length < 1"
                          :maxlength="numdocumentId"
                          v-model="documentId"
                          @input="fn_selector"
                          dense
                        ></v-text-field
                      ></v-flex>
                    </v-layout>
                    <!-- ประเภทเอกสาร -->
                    <v-layout row wrap  mt-n4 v-if="item === 'document_name'">
                      <v-flex lg3 md3 sm3 xs3 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numdocumentName"
                          :oninput="numberRegex"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2>
                        <v-text-field
                          outlined
                          :label="
                            $t('settingsms_template.dialog.document_name')
                          "
                          v-model="documentName"
                          counter
                          :disabled="numdocumentName.length < 1"
                          :maxlength="numdocumentName"
                          @input="fn_selector"
                          dense
                        ></v-text-field
                      ></v-flex>
                    </v-layout>
                    <!-- เอกสารลงวันที่ -->
                    <v-layout row wrap  mt-n4 v-if="item === 'document_date'">
                      <v-flex lg3 md3 sm3 xs3 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numDocumentDate"
                          :oninput="numberRegex"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2>
                        <v-text-field
                          outlined
                          :label="
                            $t('settingsms_template.dialog.document_date')
                          "
                          v-model="documentDate"
                          counter
                          :disabled="numDocumentDate.length < 1"
                          :maxlength="numDocumentDate"
                          @input="fn_selector"
                          dense
                        ></v-text-field
                      ></v-flex>
                    </v-layout>
                    <!-- FLEX FIELD-->
                    <v-layout row wrap  mt-n4 v-if="item === 'flex_field'">
                      <v-flex lg3 md3 sm3 xs3 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numFlexField"
                          :oninput="numberRegex"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.flex_field')"
                          v-model="flexField"
                          counter
                          :disabled="numFlexField.length < 1"
                          :maxlength="numFlexField"
                          @input="fn_selector"
                          dense
                        ></v-text-field
                      ></v-flex>
                    </v-layout>
                    <!-- เลขที่เอกสารอ้างอิง-->
                    <v-layout
                      row
                      wrap
                      mt-n4
                      v-if="item === 'additinal_ref_assign_id'"
                    >
                      <v-flex lg3 md3 sm3 xs3 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numAdditinalRefAssignId"
                          :oninput="numberRegex"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2>
                        <v-text-field
                          outlined
                          :label="
                            $t(
                              'settingsms_template.dialog.additinal_ref_assign_id'
                            )
                          "
                          v-model="additinalRefAssignId"
                          counter
                          :disabled="numAdditinalRefAssignId.length < 1"
                          :maxlength="numAdditinalRefAssignId"
                          @input="fn_selector"
                          dense
                        ></v-text-field
                      ></v-flex>
                    </v-layout>
                    <!-- สาเหตุการออกเอกสาร-->
                    <v-layout row wrap  mt-n4 v-if="item === 'create_purpose'">
                      <v-flex lg3 md3 sm3 xs3 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numCreatePurpose"
                          :oninput="numberRegex"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2>
                        <v-text-field
                          outlined
                          :label="
                            $t('settingsms_template.dialog.create_purpose')
                          "
                          v-model="createPurpose"
                          counter
                          :disabled="numCreatePurpose.length < 1"
                          :maxlength="numCreatePurpose"
                          @input="fn_selector"
                          dense
                        ></v-text-field
                      ></v-flex>
                    </v-layout>
                    <!-- URL สำหรับเรียกดูเอกสาร-->
                    <v-layout row wrap  mt-n4 v-if="item === 'url_chat'">
                      <v-flex lg3 md3 sm3 xs3 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numUrlChat"
                          :oninput="numberRegex"
                          dense
                          disabled
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.url_chat')"
                          v-model="urlChat"
                          counter
                          disabled
                          :maxlength="numUrlChat"
                          dense
                        ></v-text-field
                      ></v-flex>
                    </v-layout>
                    <!-- จำนวนเงินรวม-->
                    <v-layout row wrap  mt-n4 v-if="item === 'grand_total_amount'">
                      <v-flex lg3 md3 sm3 xs3 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numGrandTotalAmount"
                          :oninput="numberRegex"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2>
                        <v-text-field
                          outlined
                          :label="
                            $t('settingsms_template.dialog.grand_total_amount')
                          "
                          v-model="grandTotalAmount"
                          counter
                          :oninput="inputCountRegex"
                          :disabled="numGrandTotalAmount.length < 1"
                          :maxlength="numGrandTotalAmount"
                          @input="fn_selector"
                          dense
                        ></v-text-field
                      ></v-flex>
                    </v-layout>
                    <!-- เลขใบสำคัญจ่าย-->
                    <v-layout row wrap  mt-n4 v-if="item === 'voucher_no'">
                      <v-flex lg3 md3 sm3 xs3 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numVoucherNo"
                          :oninput="numberRegex"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.voucher_no')"
                          v-model="voucherNo"
                          counter
                          :disabled="numVoucherNo.length < 1"
                          :maxlength="numVoucherNo"
                          @input="fn_selector"
                          dense
                        ></v-text-field
                      ></v-flex>
                    </v-layout>
                    <!-- Document remark1-->
                    <v-layout row wrap  mt-n4 v-if="item === 'document_remark1'">
                      <v-flex lg3 md3 sm3 xs3 pa-2>
                        <v-text-field
                          outlined
                          :label="$t('settingsms_template.dialog.number')"
                          v-model="numDocumentRemark1"
                          :oninput="numberRegex"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg8 md8 sm8 xs8 pa-2>
                        <v-text-field
                          outlined
                          :label="
                            $t('settingsms_template.dialog.document_remark1')
                          "
                          v-model="documentRemark1"
                          counter
                          :disabled="numDocumentRemark1.length < 1"
                          :maxlength="numDocumentRemark1"
                          @input="fn_selector"
                          dense
                        ></v-text-field
                      ></v-flex>
                    </v-layout>
                  </div>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="fn_clearData" outlined color="#f05c5a">{{
            $t("settingemail.dialog.btn_cancle")
          }}</v-btn>
          <v-btn @click="fn_preview" color="#609cd4" dark class="ma-2">
            {{ $t("settingsms_template.dialog.test_sms") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";
import { mask } from "vue-the-mask";
import { mapGetters, mapState } from "vuex";

export default {
  directives: { mask },
  props: ["show", "data", "subjectEmail"],
  data() {
    return {
      mask: "###-#######",
      dialog: true,
      inputPhone: "",
      dataSmsPreview: "",
      newDataPreview: [],
      numCreditSms: 0,
      bussinessName: "",
      numBussinessName: "",
      sellerBranchId: "",
      numsellerBranchId: 5,
      buyerName: "",
      numbuyerName: "",
      buyerTaxId: "",
      numbuyerTaxId: "",
      buyerBranchId: "",
      numbuyerBranchId: 5,
      documentId: "",
      numdocumentId: "",
      documentName: "",
      numdocumentName: "",
      documentDate: "",
      numDocumentDate: "",
      flexField: "",
      numFlexField: "",
      additinalRefAssignId: "",
      numAdditinalRefAssignId: "",
      createPurpose: "",
      numCreatePurpose: "",
      urlChat: "",
      numUrlChat: "",
      grandTotalAmount: "",
      numGrandTotalAmount: "",
      voucherNo: "",
      numVoucherNo: "",
      documentRemark1: "",
      numDocumentRemark1: "",
      showUrl: false,
      phoneRegex:
        "this.value = this.value.replace(/[^0-9]|/g, '').substr(0,10)",
      inputNumberRegex: "this.value = this.value.replace(/[^0-9]|/g, '')",
      inputCountRegex: "this.value = this.value.replace(/[^0-9.]|/g, '')",
      numberRegex:
        "this.value = this.value.replace(/[^0-9]|/g, '').substr(0,5)",
    };
  },
  methods: {
    fn_selector() {
      this.dataSmsPreview = this.data
      const vm = this
      for(var i=0; i < this.smsContent.length; i++  ) {
        const regex = this.smsContent[i].key
        if(this.smsContent[i].value != "") {
          vm.dataSmsPreview = vm.dataSmsPreview.replaceAll(regex, this.smsContent[i].value)
        }
      }
    },
    async fn_preview() {
      if (this.$refs.form.validate()) {
        let payload = {
          taxid: this._taxId,
          sms_message: this.dataSmsPreview,
          phone: this.inputPhone,
        };
        this.axios
          .post(
            process.env.VUE_APP_SERVICE_RESENDMAIL_API + "/preview_sms",
            payload
          )
          .then((res) => {
            if (res.data.status == "OK") {
              this.fn_clearData();
              swal.fire(
                this.$t("alert.success"),
                this.$t("settingsms_template.dialog.sms_success"),
                "success"
              );
            } else {
              swal.fire(this.$t("alert.fail"), res.data.errorMessage, "error");
            }
          })
          .catch((error) => {
            if (error.response) {
              swal.fire(
                this.$t("alert.fail"),
                String(error.response.data.errorMessage),
                "error"
              );
              // do something
            } else if (error.request) {
              swal.fire(this.$t("alert.fail"), error.request, "error");
            } else if (error.message) {
              console.log(error.message);
              // do something other than the other two
            } else {
              swal.fire(this.$t("alert.fail"), String(error), "error");
            }
          });
      }
    },
    async fn_getDataURL() {
      let payload = {
        taxid: this._taxId,
      };
      this.axios
        .post(process.env.VUE_APP_SERVICE_RESENDMAIL_API + "/get_link", payload)
        .then((res) => {
          if (res.data.status == "OK") {
            this.urlChat = res.data.url_chat;
            this.fn_selector()
            this.numUrlChat = res.data.count;
            this.showUrl = true;
          } else {
            swal.fire(this.$t("alert.fail"), res.data.errorMessage, "error");
          }
        })
        .catch((error) => {
          if (error.response) {
            swal.fire(
              this.$t("alert.fail"),
              String(error.response.data.errorMessage),
              "error"
            );
            // do something
          } else if (error.request) {
            swal.fire(this.$t("alert.fail"), error.request, "error");
          } else if (error.message) {
            console.log(error.message);
            // do something other than the other two
          } else {
            swal.fire(this.$t("alert.fail"), String(error), "error");
          }
        });
    },
    fn_clearData() {
      this.bussinessName = "";
      this.sellerBranchId = "";
      this.buyerName = "";
      this.buyerTaxId = "";
      this.buyerBranchId = "";
      this.documentId = "";
      this.documentName = "";
      this.documentDate = "";
      this.flexField = "";
      this.additinalRefAssignId = "";
      this.createPurpose = "";
      this.urlChat = "";
      this.grandTotalAmount = "";
      this.voucherNo = "";
      this.documentRemark1 = "";
      this.numBussinessName = "";
      this.numsellerBranchId = 5;
      this.numbuyerName = "";
      this.numbuyerTaxId = "";
      this.numbuyerBranchId = 5;
      this.numdocumentId = "";
      this.numdocumentName = "";
      this.numDocumentDate = "";
      this.numFlexField = "";
      this.numAdditinalRefAssignId = "";
      this.numCreatePurpose = "";
      this.numUrlChat = "";
      this.numGrandTotalAmount = "";
      this.numVoucherNo = "";
      this.numDocumentRemark1 = "";
      this.data = [];
      this.newDataPreview = [];
      this.dataSmsPreview = "";
      this.$emit("closeDialogPreview");
    },
  },
  watch: {
    show(val) {
      this.newDataPreview = [];
      const vm = this
      if (val === true && this.data.length > 0) {
        this.dataSmsPreview = vm.data
        let dataSplit = this.data.split(/{{(.*?)}}/);
        for (var item of dataSplit) {
          let index = this.newDataPreview.findIndex(
            (element) => element === item
          );
          if (index < 0) {
            this.newDataPreview.push(item);
            if (item == "url_chat") {
              this.fn_getDataURL();
            }
          }
        }
        // } else {
        //   this.newDataPreview = [];
      }
    },
    dataSmsPreview(val) {
      if (val.length <= 70) {
        this.numCreditSms = 1;
      } else {
        var newCount = this.dataSmsPreview.length / 70;
        this.numCreditSms = Number(newCount).toLocaleString("en-US", {
          minimumFractionDigits: 2,
        });
      }
    },
  },
  computed: {
    ...mapState(["backgroudcolor", "pageDetailcolor", "cardTitle"]),
    ...mapGetters(["getter_dataBusiness_profile"]),
    _taxId: {
      get() {
        return this.getter_dataBusiness_profile["id_card_num"];
      },
    },
    _backgroudcolor: {
      get() {
        return this.backgroudcolor;
      },
    },
    _cardTitle: {
      get() {
        return this.cardTitle;
      },
    },
    _pageDetailcolor: {
      get() {
        return this.pageDetailcolor;
      },
    },
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogPreview");
        }
      },
    },
    smsContent: {
      get() {
        const vm = this
        return [
          { key: "{{bussiness_name}}", value: vm.bussinessName },
          { key: "{{seller_branch_id}}", value: vm.sellerBranchId },
          { key: "{{buyer_name}}", value: vm.buyerName },
          { key: "{{buyer_tax_id}}", value: vm.buyerTaxId },
          { key: "{{buyer_branch_id}}", value: vm.buyerBranchId },
          { key: "{{document_id}}", value: vm.documentId },
          { key: "{{document_name}}", value: vm.documentName },
          { key: "{{document_date}}", value: vm.documentDate },
          { key: "{{flex_field}}", value: vm.flexField },
          {
            key: "{{additinal_ref_assign_id}}",
            value: vm.additinalRefAssignId,
          },
          { key: "{{create_purpose}}", value: vm.createPurpose },
          { key: "{{grand_total_amount}}", value: vm.grandTotalAmount },
          { key: "{{voucher_no}}", value: vm.voucherNo },
          { key: "{{document_remark1}}", value: vm.documentRemark1 },
          { key: "{{url_chat}}", value: vm.urlChat },
        ];
      },
    },
  },
};
</script>
<style scoped>
.message-blue {
  position: relative;
  margin-left: 20px;
  /* margin-bottom: 10px; */
  padding: 10px;
  background-color: #a8ddfd;
  width: 520px;
  height: 200px;
  text-align: left;
  border: 1px solid #97c6e3;
  border-radius: 10px;
}
.message-content {
  padding: 0;
  margin: 0;
}

.message-timestamp-right {
  position: absolute;
  font-size: 0.85em;
  font-weight: 300;
  bottom: 10px;
  right: 5px;
}

.message-timestamp-left {
  position: absolute;
  font-size: 0.85em;
  font-weight: 300;
  bottom: 5px;
  left: 5px;
}

.message-blue:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-top: 15px solid #a8ddfd;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  top: 0;
  left: -15px;
}

.message-blue:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-top: 17px solid #97c6e3;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  top: -1px;
  left: -17px;
}
</style>
